import imageOne from '@/assets/images/cities/saskatoon1.jpg'
import imageTwo from '@/assets/images/cities/saskatoon2.jpg'
import imageThree from '@/assets/images/cities/saskatoon3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Saskatoon',
  writeup: '',
  website: 'SaskatoonNotaryPublic.com',
  url: 'https://www.saskatoonnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(306) 500-5160',
      hours: {
        monday: '9:00AM to 4:30PM',
        tuesday: '9:00AM to 4:30PM',
        wednesday: '9:00AM to 4:30PM',
        thursday: '9:00AM to 4:30PM',
        friday: '9:00AM to 4:30PM',
        saturday: '',
        sunday: ''
      },
      address: '3rd Avenue North Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/cities/saskatoon.js